import { UploadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Select, Upload, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useBooks } from "./BookStore";
import { API_URL, MAIN_URL } from "../../../Constants";

function Add() {
    const formRef = useRef();
    let [autors, setAutors] = useState([]);
    let [cats, setCats] = useState([]);
    let [userImg, setUserImg] = useState(API_URL + '/upload/user/defuser.png');
    let [userFile, setUserFile] = useState(API_URL + '/upload/user/defuser.png');
    let [lang, setLang] = useState([]);
    let [nashriyot, setNashriyot] = useState([]);

    let { add } = useBooks()

    useEffect(() => {
        axios.get('/bookautors')
            .then(res => setAutors(res.data))
            .catch(err => console.error('Muallif yuklab olishda xatolik:', err))
        axios.get('/bookcats')
            .then(res => setCats(res.data))
            .catch(err => console.error('Kategoriya yuklab olishda xatolik:', err))
        axios.get('/til')
            .then(res => setLang(res.data))
            .catch(err => console.error('Til yuklab olishda xatolik:', err))
        axios.get('/nashr')
            .then(res => setNashriyot(res.data))
            .catch(err => console.error('Nashriyot yuklab olishda xatolik:', err))
    }, []);

    const createUploadProps = (setFunction, fileType = 'image') => ({
        name: 'image',
        action: API_URL + '/file',
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            if (info.file.status !== 'uploading' && info.file.response?.data?.image) {
                setFunction(MAIN_URL + '/' + info.file.response.data.image)
            }
            if (info.file.status === 'done') {
                message.success(`${info.file.name} muaffaqiyatli yuklab olindi`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} yuklab olishda xatolik.`);
            }
        },
    });

    const onFinish = (values) => {
        values.year = values.year.format('YYYY');
        let data = { ...values, img: userImg, url: userFile }
        add(data);
        formRef.current?.resetFields();
        setUserImg(API_URL + '/upload/user/defuser.png');
        setUserFile(API_URL + '/upload/user/defuser.png');
    }

    const propsImage = createUploadProps(setUserImg);
    const propsFile = createUploadProps(setUserFile);

    return (
        <>
            <Form
                ref={formRef}
                name="basic"
                labelCol={{
                    span: 24,
                }}
                wrapperCol={{
                    span: 24,
                }}
                onFinish={onFinish}
                autoComplete="off"
            >
                <fieldset>
                    <legend>Kirish ma'lumotlari</legend>
                    <Form.Item
                        label="Kitob nomi"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Iltimos to'ldiring!",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Row gutter={15}>
                        <Col span={12}>
                            <Form.Item label="Rasmni yuklang" valuePropName="img">
                                <Upload {...propsImage}>
                                    <Button icon={<UploadOutlined />}>Выбрать</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Faylni yuklang" valuePropName="url">
                                <Upload {...propsFile}>
                                    <Button icon={<UploadOutlined />}>Выбрать</Button>
                                </Upload>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="Chiqarilgan Yilini tanlang"
                                name="year"
                                rules={[
                                    {
                                        required: true,
                                        message: "Iltimos to'ldiring!",
                                    },
                                ]}
                            >
                                <DatePicker picker="year" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Chiqarilgan joyini tanlang"
                                name="joy"
                                rules={[
                                    {
                                        required: true,
                                        message: "Iltimos to'ldiring!",
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Muallif"
                                name="autor_id"
                                rules={[
                                    {
                                        required: true,
                                        message: "Iltimos to'ldiring!",
                                    },
                                ]}
                            >
                                <Select
                                    options={autors?.map(item => {
                                        return { value: item.id, label: item.fullname }
                                    })}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Bo'lim"
                                name="cat_id"
                                rules={[
                                    {
                                        required: true,
                                        message: "Iltimos to'ldiring!",
                                    },
                                ]}
                            >
                                <Select
                                    options={cats?.map(item => {
                                        return { value: item.id, label: item.name }
                                    })}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Nashriyot"
                                name="nashr_id"
                                rules={[
                                    {
                                        required: true,
                                        message: "Iltimos to'ldiring!",
                                    },
                                ]}
                            >
                                <Select
                                    options={nashriyot?.map(item => {
                                        return { value: item.id, label: item.nashriyot }
                                    })}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Tilni tanlang"
                                name="lang_id"
                                rules={[
                                    {
                                        required: true,
                                        message: "Iltimos to'ldiring!",
                                    },
                                ]}
                            >
                                <Select
                                    options={lang?.map(item => {
                                        return { value: item.id, label: item.til }
                                    })}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item
                        label="Kitob haqida"
                        name="izoh"
                        rules={[
                            {
                                required: true,
                                message: "Iltimos to'ldiring!",
                            },
                        ]}
                    >
                        <Input.TextArea />
                    </Form.Item>
                </fieldset>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Saqlash
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}

export default Add;